import { IxcRegistrationV1UsState } from '@interxfi/types/generated/api';

// As per https://github.com/interxfi/api/blob/main/external/ixc/registration/v1/controls.j5s#L185
export const ALL_US_STATES_AND_TERRITORIES: IxcRegistrationV1UsState[] = Object.values(IxcRegistrationV1UsState).filter((stateOrTerritory) => {
  return ![
    IxcRegistrationV1UsState.Unspecified,
    IxcRegistrationV1UsState.As,
    IxcRegistrationV1UsState.Gu,
    IxcRegistrationV1UsState.Mp,
    IxcRegistrationV1UsState.Um,
    IxcRegistrationV1UsState.Aa,
    IxcRegistrationV1UsState.Ae,
    IxcRegistrationV1UsState.Ap,
  ].includes(stateOrTerritory);
});

function testAllMatch(selections: IxcRegistrationV1UsState[] | undefined, required: IxcRegistrationV1UsState[]): boolean {
  if (!selections) {
    return false;
  }

  if (selections.length !== required.length) {
    return false;
  }

  const stateSet = new Set(selections);
  for (const stateOrTerritory of required) {
    if (!stateSet.has(stateOrTerritory)) {
      return false;
    }
  }

  return true;
}

export function getHasAllUsStatesAndTerritoriesSelected(states: IxcRegistrationV1UsState[] | undefined): boolean {
  return testAllMatch(states, ALL_US_STATES_AND_TERRITORIES);
}

export const ALL_US_STATES_AND_DC: IxcRegistrationV1UsState[] = ALL_US_STATES_AND_TERRITORIES.filter(
  (state) => state !== IxcRegistrationV1UsState.Pr && state !== IxcRegistrationV1UsState.Vi,
);

export function getHasAllUsStatesAndDcSelected(states: IxcRegistrationV1UsState[] | undefined): boolean {
  return testAllMatch(states, ALL_US_STATES_AND_DC);
}
